import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/icomoon/style.css';
import './index.css';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom'
import {createBrowserHistory} from 'history'
import {connect} from 'react-redux';
import axios from "axios";
import Page404 from './components/common/page404';

import Login from './components/auth/Login'
import Address from './components/view/address'
import UserList from './components/view/userList'
import businessUserList from './components/view/businessUser'
import UserDishes from './components/view/userDishes'
import TicketsPurchases from './components/view/ticketsPurchases'
import BusinessSubscription from './components/view/businessSubscription'
import ReasonList from './components/view/reasons'
import ReportList from './components/view/reports'
import SurveyList from './components/view/surveys'
import UserDetail from './components/view/UserDetails'
import Setting from './components/view/settings'
import ForgotPassword from './components/auth/ForgotPassword'
import ResetPassword from './components/auth/ResetPassword'
// import Dishes from "./components/view/ticketsPurchases";
import Badges from "./components/view/Events"
import Events from "./components/view/Events";
import Venues from "./components/view/Venues";


export const history = createBrowserHistory();


const PrivateRoute = ({component: Component, ...rest}) => (
    <Route {...rest} render={props => (localStorage.getItem('accessToken') ? <Component {...props} />: <Redirect to={{pathname: '/', state: {from: props.location}}}/>
    )}/>
)
const PrivateOuterRoute = ({component: Component, ...rest}) => (
    <Route {...rest} render={props => (localStorage.getItem('accessToken') ? <Redirect to={{pathname: '/users', state: {from: props.location}}}/>
            : <Component {...props} />
    )}/>
)
class Routes extends Component {
    constructor(props) {
        super(props);
        const {dispatch} = this.props;
        history.listen((location, action) => {

        });
    }


    render() {
        let accessToken = localStorage.getItem('accessToken');
        if (accessToken) {

            axios.defaults.headers.common['accessToken'] = `${accessToken}`;
        }
        axios.defaults.headers.common['Authorization'] = `${'Basic ZGluZzpkaW5nQDEyMw=='}`;


        return (
            <>
                <Router history={history}>


                    <Switch>
                        <PrivateOuterRoute exact path="/" component={Login}/>
                        <PrivateOuterRoute exact path="/forgot-password" component={ForgotPassword}/>
                        <PrivateOuterRoute exact path="/reset-password/:id" component={ResetPassword}/>
                        <PrivateRoute path="/users" component={UserList}/>
                        <PrivateRoute path="/business-user" component={businessUserList}/>
                        <PrivateRoute path="/reports" component={ReportList}/>
                        <PrivateRoute path="/surveys" component={SurveyList}/>
                        <PrivateRoute path="/reasons" component={ReasonList}/>
                        <PrivateRoute path="/user-info/:id" component={UserDetail}/>
                        <PrivateRoute path="/business-info/:id" component={UserDetail}/>
                        <PrivateRoute path="/settings" component={Setting}/>
                        <PrivateRoute path="/events" component={Events}/>
                        <PrivateRoute path="/venues" component={Venues}/>

                        // <PrivateOuterRoute exact path="/" component={Login}/>
                        <PrivateRoute path="/address" component={Address}/>
                        {/*<PrivateRoute path="/dish/:id" component={Dishes}/>*/}
                        <PrivateRoute path="/user-dish/:id" component={UserDishes}/>
                        <PrivateRoute path="/tickets-purchased" component={TicketsPurchases}/>
                        <PrivateRoute path="/subscription-purchased" component={BusinessSubscription}/>
                        // <PrivateRoute path="/user-info/:id" component={UserDetail}/>
                        // <PrivateRoute path="/settings" component={Setting}/>
                    </Switch>


                </Router>
            </>
        )
    }
}


function mapStateToProps(state) {
    const {alert} = state;
    return {
        alert
    };
}
export default connect(mapStateToProps)(Routes);
